import React from 'react';

const ViewToggle = ({ view, onToggle }) => (
  <div className="inline-flex rounded-lg bg-white border border-slate-200 shadow-sm p-1">
    <button onClick={() => onToggle('table')}
      className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${view === 'table' ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
      Table
    </button>
    <button onClick={() => onToggle('cards')}
      className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${view === 'cards' ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
      Cards
    </button>
  </div>
);

export default ViewToggle;
